import React, { useState } from 'react';
import Modalfeed from '../../feedback/modal/modalfeed';
import Modalstar from '../../feedback/modal/modalstar';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Feedback = () => {
  const [showStarModal, setShowStarModal] = useState(true);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const id = localStorage.getItem('id');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [quizz, setQuizz] = useState({
    quiz: id,
    ratings: "0",
    review: ""
  });

  const handleStarModalClose = () => {
    setShowStarModal(false);
  };

  const handleFeedbackClick = () => {
    setShowStarModal(false);
    setShowFeedbackModal(true);
  };

  const handleFeedbackModalClose = () => {
    setShowFeedbackModal(false);
  };

  const handleRating = (rate) => {
    setQuizz(prevState => ({
      ...prevState,
      ratings: rate
    }));
  };

  const handleReviewChange = (e) => {
    setQuizz(prevState => ({
      ...prevState,
      review: e.target.value
    }));
  };

  return (
    <>
      <Modalstar 
        show={showStarModal} 
        onHide={handleStarModalClose}
        onFeedbackClick={handleFeedbackClick}
        quizz={quizz}
        onRating={handleRating}
        navigate={navigate}
        dispatch={dispatch}
      />
      <Modalfeed 
        show={showFeedbackModal}
        onHide={handleFeedbackModalClose}
        quizz={quizz}
        onReviewChange={handleReviewChange}
        navigate={navigate}
        dispatch={dispatch}
      />
    </>
  );
};

export default Feedback;